export default __webpack_public_path__ + "daa9a64347435b928f332de28669b0ef.png";